import { FC, MouseEvent, useState } from 'react';
import cx from 'classnames';
import type { LucideIcon as LucideIconType } from 'lucide-react';
import { FLATTENED_COLOURS } from '../../common/styles/vars';

export interface LucideIconProps {
  icon: LucideIconType;
  size?: number | string;
  color?: string;
  hoverColor?: string;
  spin?: boolean;
  className?: string;
  /** When provided, wraps the icon in a <div> with this className and moves onClick/hover to the wrapper. */
  wrapperClassName?: string;
  onClick?: (e: MouseEvent) => void;
}

const resolveColor = (color?: string): string | undefined =>
  (color && FLATTENED_COLOURS[color]) || color;

const LucideIcon: FC<LucideIconProps> = ({
  icon: Component,
  size = 24,
  color,
  hoverColor,
  spin,
  className,
  wrapperClassName,
  onClick
}) => {
  const [hovered, setHovered] = useState(false);
  const activeColor = hovered && hoverColor ? hoverColor : color;
  const composedClassName = cx(className, { spin }) || undefined;

  const hoverHandlers = hoverColor
    ? {
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => setHovered(false)
      }
    : {};

  const svg = (
    <Component
      size={size}
      color={resolveColor(activeColor)}
      className={composedClassName}
    />
  );

  if (wrapperClassName) {
    return (
      <div className={wrapperClassName} onClick={onClick} {...hoverHandlers}>
        {svg}
      </div>
    );
  }

  return (
    <Component
      size={size}
      color={resolveColor(activeColor)}
      className={composedClassName}
      onClick={onClick}
      {...hoverHandlers}
    />
  );
};

export default LucideIcon;
